enum CurrencyType {
	None,
	Virtual,
	Fiat,
}

export default CurrencyType;
